import * as React from 'react';
import {
  Controller, useFieldArray, useFormContext,
} from 'react-hook-form';
import {
  ErrorMessage,
  PrimaryButton,
  PrimaryTextField,
  IconLoadingButton,
} from 'components';
import {
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';

import { PlusIcon, CloseSquareIcon } from 'assets/icons';
import { selectStatistics } from 'base/auth/selectors';
import { IUpdateProfileForm } from '../../interface';

const StatisticsForm = () => {
  const { control, formState: { errors } } = useFormContext<IUpdateProfileForm>();
  const { fields, append, remove } = useFieldArray({ name: 'statistics', control });

  const statistics = useSelector(selectStatistics);

  const addStatistic = () => { append({ title: '', description: '' }); };
  const removeStatistic = (i:number) => {
    remove(i);
  };

  React.useEffect(() => {
    remove();
    if (statistics) {
      statistics.forEach((statistic) => {
        append({ title: statistic.title, description: statistic.description });
      });
    }
  }, [statistics]);

  return (
    <>
      <div className="form-item">
        <Typography variant="h5" sx={{ mb: 2 }}>Statistics</Typography>
      </div>
      <div className="row">
        {fields.map((item, i) => (
          <div key={item.id} className="col-md-6">
            <div className="form-item">
              <div className="mb-2">
                <div className="mb-2">
                  <Typography variant="body1">
                    Statistic #
                    {' '}
                    {i + 1}
                  </Typography>
                </div>
                <div className="form-item">
                  <Controller
                    name={`statistics.${i as 0}.title`}
                    control={control}
                    render={({ field }) => <PrimaryTextField {...field} label="Title" />}
                  />
                </div>
                <div className="form-item">
                  <Controller
                    name={`statistics.${i as 0}.description`}
                    control={control}
                    render={({ field }) => <PrimaryTextField {...field} label="Description" />}
                  />
                </div>
                <IconLoadingButton
                  startIcon={<CloseSquareIcon />}
                  onClick={() => removeStatistic(i)}
                >
                  Remove
                </IconLoadingButton>
              </div>
              <ErrorMessage>
                {errors?.statistics ? errors?.statistics[i]?.title?.message : ' '}
              </ErrorMessage>
            </div>
          </div>
        ))}
      </div>
      <PrimaryButton
        startIcon={<PlusIcon sx={{ color: '#fff' }} />}
        onClick={addStatistic}
      >
        Add a new statistic
      </PrimaryButton>
    </>
  );
};

export default StatisticsForm;
